import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EntryIdentifier } from './container-edit.actions';

export type EntryEditingState = {
  entryBeingEdited: EntryIdentifier | null;
};

export const STATE_FEATURE_ENTRY_EDITING = 'entryEditing';

export const ENTRY_EDITING_INITIAL_STATE: EntryEditingState = {
  entryBeingEdited: null,
};

export const selectEntryEditing = createFeatureSelector<EntryEditingState>(
  STATE_FEATURE_ENTRY_EDITING,
);

export const selectEntryBeingEdited = createSelector(
  selectEntryEditing,
  (state: EntryEditingState) => state.entryBeingEdited,
);

export function getInitialEntryEditingState(): EntryEditingState {
  return ENTRY_EDITING_INITIAL_STATE;
}
